module.exports = __webpack_public_path__ + "img/government_doh.bb5998dc.svg";